module.exports = __webpack_public_path__ + "static/media/unauth_image2.a979a6e3.jpg";